module.exports = __webpack_public_path__ + "dxicons.9c18694294666d556dd5.woff";


//////////////////
// WEBPACK FOOTER
// C:/Software Development/Devpark/biz-app/~/devextreme/dist/css/icons/dxicons.woff
// module id = ../../../../devextreme/dist/css/icons/dxicons.woff
// module chunks = 8